module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.9839/images/homepage/corner-blobs.png"